var _defs, _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG12({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.943,
    height: 80.947,
    viewBox: "0 0 80.943 80.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.943,
    height: 80.947,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.943,
    height: 80.947,
    transform: "translate(0 0)",
    fill: "#bf8c2e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08,10.636h.025V23.13h2.744V6.809H8.656L6.13,9.77v2.864h.023Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.485,10.179v1.973h2.5V10.106c0-.987.483-1.275,1.059-1.275.531,0,.988.216.988,1.228v1.347a3.235,3.235,0,0,1-1.012,2.816l-1.54,1.637c-1.492,1.59-2.047,2.649-2.047,4.262V23.13h7.126V20.89h-4.5v-.769a3.118,3.118,0,0,1,1.155-2.5l1.758-1.853a5.14,5.14,0,0,0,1.734-4.117V10.059c0-2.336-1.131-3.443-3.587-3.443-2.408,0-3.635,1.276-3.635,3.563",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.64,43.361a14.625,14.625,0,0,0-8.808-2.888,9.738,9.738,0,0,0-2.126.2l-.217.051c-2.091.494-5.59,1.32-9.664,6.375l-.119.149a.523.523,0,0,0-.1.306.546.546,0,0,0,.071.268l.093.151q1.008,1.688,1.675,2.931a.539.539,0,0,0,.872.122c.028-.037.057-.076.076-.107,3.518-4.866,6.276-5.515,8.1-5.944l.226-.053a5.345,5.345,0,0,1,1.118-.095,10.352,10.352,0,0,1,6.1,1.957c2.047,1.616,3.085,4.2,3.085,7.67,0,5.821-2.816,8.091-5.18,8.971a8.215,8.215,0,0,1-2.888.508,10.266,10.266,0,0,1-4.331-.987l-.169-.082c-2.033-.882-5.067-2.722-7.936-8.484C36.631,42.571,31.69,41.452,28.419,40.711l-.172-.038a9.813,9.813,0,0,0-2.108-.19,14.038,14.038,0,0,0-8.662,2.866c-2.132,1.7-4.675,5.005-4.675,11.085A12.836,12.836,0,0,0,25.841,68.062a15.947,15.947,0,0,0,2.989-.292,12.742,12.742,0,0,0,5.1-2.33l1.721,1.552a.514.514,0,0,0,.7-.032.455.455,0,0,0,.124-.327l1.331-8.2v-.1a.486.486,0,0,0-.16-.357.479.479,0,0,0-.345-.127h0l-7.982,2.206-.151.025a.458.458,0,0,0-.254.147.493.493,0,0,0,.034.7l1.653,1.495a7.813,7.813,0,0,1-2.583,1.05,11.292,11.292,0,0,1-2.118.207,8.638,8.638,0,0,1-6.839-3.094l-.044-.061a8.774,8.774,0,0,1-1.841-6.1c0-3.485,1.02-6.067,3.031-7.674a10.035,10.035,0,0,1,5.949-1.924,5.538,5.538,0,0,1,1.131.1l.176.039c2.612.591,6.188,1.4,11.146,11.36,2.618,5.258,5.9,8.7,10.03,10.51a14.764,14.764,0,0,0,6.321,1.466,12.633,12.633,0,0,0,4.412-.782c2.41-.9,8.019-3.975,8.019-13.066,0-6.075-2.58-9.388-4.744-11.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.948,7.682V9.74h.37a.482.482,0,0,0,.547-.546V8.219c0-.361-.166-.537-.547-.537Zm0,2.673v3.034H25.835V6.775h1.62c1.121,0,1.531.556,1.531,1.483v.848c0,.713-.253,1.132-.888,1.278l1.064,3.005H27.991Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.582,6.775h2.654v.907H30.694V9.575h1.1v.9h-1.1v2.01h1.542v.907H29.582Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.764,11.965v-.888H33.8v.908c0,.37.166.585.547.585.35,0,.507-.234.507-.585v-.254a1.2,1.2,0,0,0-.5-.937l-.653-.653a2.232,2.232,0,0,1-.927-1.766V8.151A1.38,1.38,0,0,1,34.335,6.7c1.112,0,1.551.546,1.551,1.5v.536H34.871V8.16c0-.38-.176-.565-.526-.565a.487.487,0,0,0-.527.546v.136c0,.371.2.586.527.9l.712.7a2.222,2.222,0,0,1,.9,1.717v.322a1.432,1.432,0,0,1-1.619,1.551,1.377,1.377,0,0,1-1.571-1.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.623,7.682v2.6h.41a.479.479,0,0,0,.547-.547V8.219c0-.361-.167-.537-.547-.537Zm-1.112-.907H38.16c1.122,0,1.532.556,1.532,1.483V9.653c0,.926-.41,1.492-1.532,1.492h-.537v2.244H36.511Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.512,11.858V8.307c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682m-2.254-.176v-3.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.186,9.233v4.156h-.937V6.775h1.093l1.2,3.794V6.775h.927v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.045,11.965v-.888h1.034v.908c0,.37.166.585.547.585.35,0,.507-.234.507-.585v-.254a1.2,1.2,0,0,0-.5-.937l-.653-.653a2.232,2.232,0,0,1-.927-1.766V8.151A1.38,1.38,0,0,1,49.616,6.7c1.112,0,1.551.546,1.551,1.5v.536H50.152V8.16c0-.38-.176-.565-.526-.565a.487.487,0,0,0-.527.546v.136c0,.371.205.586.527.9l.712.7a2.222,2.222,0,0,1,.9,1.717v.322a1.432,1.432,0,0,1-1.619,1.551,1.377,1.377,0,0,1-1.571-1.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(51.792 6.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.651,10.414v2.068h.488a.479.479,0,0,0,.547-.537V10.95c0-.351-.166-.536-.556-.536Zm0-.849h.391a.468.468,0,0,0,.526-.537V8.219a.468.468,0,0,0-.536-.537h-.381Zm-1.112-2.79h1.61c1.112,0,1.483.517,1.483,1.453V8.9a.963.963,0,0,1-.664,1.054,1,1,0,0,1,.83,1.1v.878c0,.937-.42,1.454-1.532,1.454H53.539Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.345,6.775h1.112v5.707h1.327v.907H57.345Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.282,6.775h2.654v.907H61.394V9.575h1.1v.9h-1.1v2.01h1.542v.907H60.282Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.836,21.4V18.2A1.56,1.56,0,0,1,27.5,16.412c1.229,0,1.57.683,1.57,1.658v.781H28.051v-.868c0-.41-.137-.644-.537-.644s-.566.283-.566.683v3.551c0,.4.166.682.566.682s.537-.253.537-.643v-1.22h1.014v1.142c0,.946-.39,1.648-1.57,1.648A1.564,1.564,0,0,1,25.836,21.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.023,21.573V18.022c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682M29.769,21.4V18.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8,18.948V23.1h-.937V16.49h1.093l1.2,3.794V16.49h.927V23.1h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.76,21.68v-.888h1.034V21.7c0,.37.166.585.547.585.35,0,.507-.234.507-.585v-.254a1.2,1.2,0,0,0-.5-.937l-.653-.653a2.231,2.231,0,0,1-.927-1.766v-.224a1.38,1.38,0,0,1,1.561-1.454c1.112,0,1.551.546,1.551,1.5v.536H39.867v-.575c0-.381-.176-.566-.526-.566a.487.487,0,0,0-.527.546v.136c0,.371.2.586.527.9l.712.7a2.222,2.222,0,0,1,.9,1.717v.322a1.432,1.432,0,0,1-1.619,1.551,1.377,1.377,0,0,1-1.571-1.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.864,16.49v5c0,1.025-.439,1.688-1.57,1.688a1.493,1.493,0,0,1-1.659-1.688v-5h1.112V21.6c0,.39.156.653.547.653s.546-.263.546-.653V16.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.659,18.812H48.63L47.879,23.1h-.517l-.829-4.292h-.02V23.1H45.6V16.49h1.3l.721,3.727h.01l.644-3.727h1.405V23.1H48.659Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.519,17.4V20h.41a.479.479,0,0,0,.547-.547V17.934c0-.361-.167-.537-.547-.537Zm-1.112-.907h1.649c1.122,0,1.532.556,1.532,1.483v1.4c0,.926-.41,1.492-1.532,1.492h-.537V23.1H50.407Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.949,16.49h2.956V17.4h-.917V23.1H54.866V17.4h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(57.432 16.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.443,21.573V18.022c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682M59.189,21.4V18.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.137,18.948V23.1H63.2V16.49h1.093l1.2,3.794V16.49h.927V23.1h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.055,30.721h.888L27.5,28.068h-.01Zm-1.4,2.1L26.909,26.2h1.268l1.258,6.614H28.294l-.2-1.21h-1.18l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.861,28.663v4.156h-.937V26.2h1.093L32.217,30V26.2h.927v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.389,31.912c.458,0,.634-.274.634-.673V27.775a.579.579,0,0,0-.634-.663H34.92v4.8Zm1.746-3.932v3.063c0,1.015-.419,1.776-1.61,1.776H33.808V26.2h1.717c1.191,0,1.61.751,1.61,1.775",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.965,27.112v2.6h.41a.479.479,0,0,0,.547-.547V27.649c0-.361-.167-.537-.547-.537ZM38.853,26.2H40.5c1.122,0,1.532.556,1.532,1.483v1.4c0,.926-.41,1.492-1.532,1.492h-.537v2.244H38.853Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.751,27.112V29.17h.371a.481.481,0,0,0,.546-.546v-.975c0-.361-.165-.537-.546-.537Zm0,2.673v3.034H42.639V26.2h1.619c1.122,0,1.532.556,1.532,1.483v.848c0,.713-.253,1.132-.888,1.278l1.064,3.005H44.795Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.679,31.287V27.736c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682m-2.254-.176v-3.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.037,31.912c.458,0,.634-.274.634-.673V27.775a.579.579,0,0,0-.634-.663h-.469v4.8Zm1.746-3.932v3.063c0,1.015-.42,1.776-1.61,1.776H50.456V26.2h1.717c1.19,0,1.61.751,1.61,1.775",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.676,26.2v5c0,1.025-.439,1.688-1.57,1.688a1.492,1.492,0,0,1-1.659-1.688v-5h1.112v5.112c0,.39.156.653.547.653s.546-.263.546-.653V26.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.34,31.111v-3.2A1.56,1.56,0,0,1,60,26.126c1.229,0,1.57.683,1.57,1.658v.781H60.555V27.7c0-.41-.137-.644-.537-.644s-.566.283-.566.683v3.551c0,.4.166.682.566.682s.537-.253.537-.643v-1.22h1.014v1.142c0,.946-.39,1.648-1.57,1.648a1.564,1.564,0,0,1-1.659-1.785",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.078,26.2h2.956v.907h-.917v5.707H62.995V27.112h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(65.561 26.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.572,31.287V27.736c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682m-2.254-.176v-3.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.265,28.663v4.156h-.937V26.2h1.093L73.621,30V26.2h.927v6.614h-.976Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG12);
export default __webpack_public_path__ + "static/media/G12.9ac5ffaffe19a38d7fbe8c6e0803e17d.svg";
export { ForwardRef as ReactComponent };